import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconVimeo = ({ id, color, width = 17.9, style, ...restProps }: IProps) => {
  const viewBoxWidth = 17.9;
  const viewBoxHeight = 13.9;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M.8 4.7l-.8-1c.3-.2.5-.4.7-.6.9-.7 1.7-1.4 2.6-2 .4-.3.9-.6 1.4-.8.9-.4 2-.2 2.6.9.3.6.5 1.2.6 1.9.2 1.3.4 2.6.8 3.8.1.5.3 1.1.6 1.5.3.6.6.6 1.1.2.6-.5 1-1.1 1.4-1.7.3-.5.7-1.1.9-1.7.1-.3.1-.5.1-.8 0-.5-.4-.8-1-.8-.4 0-.8 0-1.2.2l-.3.1c.1-.1.1-.3.1-.4.3-1 .8-1.8 1.6-2.5.8-.6 1.7-.9 2.7-1 .5 0 .9 0 1.4.1.9.2 1.4.8 1.7 1.6.3 1.1.2 2.2-.3 3.2-.5 1.1-1.2 2.1-1.9 3-1 1.3-2 2.5-3.2 3.6-.8.7-1.6 1.4-2.6 1.9-.5.2-1 .4-1.6.4-.7.2-1.2-.1-1.6-.6-.6-.7-1-1.5-1.3-2.4-.5-1.6-1-3.1-1.5-4.7-.2-.6-.4-1.2-.8-1.7l-.3-.3c-.2-.1-.5-.2-.7 0l-1.2.6"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconVimeo;
